import React from "react";
import {TableButton} from "./TableButton";

export const ProfileButton = ({row, isIntegrationUser}) => {


    return (<TableButton
            href={'/gerenciar/profiles/form/' + row.original.id + (isIntegrationUser ? '?isIntegrationUser=true' : '')}
            title="Permissões" className="bg-green">
            <i className="fas fa-users" aria-hidden="true"></i>
        </TableButton>


    )
}
